// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".system-setting[data-v-c99aed2c] {\n  height: 100%;\n  box-sizing: border-box;\n  padding-top: 0.26667rem;\n}\n.system-setting .setting-list[data-v-c99aed2c] {\n  height: 100%;\n  overflow: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
